import React from 'react';
import './App.css';

const Spinner = () => {
  return <div className="loader"></div>;
};

export default Spinner;